import * as React from 'react';
import cx from 'classnames';

import Container, { Props as ContainerProps } from 'components/Container';

import './styles/CenteredContainer.scss';

export enum LoadingIndicatorBackgroundColorEnum {
  paper = 'paper',
}
export type LoadingIndicatorBackgroundColor =
  | keyof typeof LoadingIndicatorBackgroundColorEnum
  | LoadingIndicatorBackgroundColorEnum;

type Props = {
  children: React.ReactNode;
  className?: string;
  backgroundColor?: LoadingIndicatorBackgroundColor;
  'data-testid'?: string;
} & ContainerProps;

function CenteredContainer(props: Props) {
  const { backgroundColor, children, className, ...others } = props;

  return (
    <div
      className={cx(
        'CenteredContainer',
        className,
        backgroundColor && `CenteredContainer--${backgroundColor}`
      )}
      data-testid={others['data-testid']}
    >
      <div className="CenteredContainer-wrap">
        <Container {...others}>{children}</Container>
      </div>
    </div>
  );
}

export default CenteredContainer;
